<template>
  <p>
    Ocorreu um erro ao gerar o novo boleto.
  </p>
  <p>
    Por favor, entre em contato com a <strong>Riachuelo</strong> para realizar o pagamento.
  </p>
</template>
